import React, { useState } from 'react';
import './SuppliesComponent.css';
import EcoProDashboard from '../../Dashboard/EcoPro/Dashboard';
import BrotherPlusDashboard from '../../Dashboard/BrotherPlus/Dashboard';
import sparkleWandIcon from '../../../assets/images/BrotherPlus/wand-magic-sparkles-icon.svg';
import sectionHeaderPrintIcon from '../../../assets/images/mydevices/sectionheader-printIcon.svg'
import UpgradeToEcoProBlock from '../../../components/CustomerDashboard/BrotherPlus/UpgradeToEcoProBlock/UpgradeToEcoProBlock';
import SectionHeader from './SectionHeader/SectionHeader';
import { useTranslation } from 'react-i18next';

export const SOURCE_MY_DEVICE = 'MyDevices';


const SuppliesComponent = (props) => {
  const {
    deviceData,
    handleDeviceInfoDetails,
    handleDeviceStatusDetails,
    showEcoWidget,
    showBplusWidget,
    isSingleService,
    isOnlyEcoCancelled,
  } = props;
  const [showUpgradeEcoProSection, setshowUpgradeEcoProSection] = useState(false);
  const { t } = useTranslation(["translation"]);
  const ecoProService = deviceData?.services?.ecopro;
  const brotherService = deviceData?.services?.brother;
  const isEcoProSuccess = ecoProService?.isSuccess === true;
  const isBrotherSuccess = brotherService?.isSuccess === true;
  const isBothServicesActive = isEcoProSuccess && isBrotherSuccess && showEcoWidget && showBplusWidget; const isMultiService = !isSingleService;
  const handleUpgradeBlockSectionVisibility = (isVisible) => {
    setshowUpgradeEcoProSection(isVisible);
  };
  const shouldShowBrotherDashboard = (isSingleService && isBrotherSuccess && !isEcoProSuccess) || (isMultiService && isOnlyEcoCancelled);

  return (
    <>
      <SectionHeader
        imageSrc={sectionHeaderPrintIcon}
        title={t("MY_DEVICES.PRINTER_DEVICE_PANEL.DEVICE_HEALTH")}
      />
      {shouldShowBrotherDashboard ? (
        <>
          <BrotherPlusDashboard
            source={SOURCE_MY_DEVICE}
            selectedDeviceID={deviceData?.deviceId}
            isBothEnrolledServices={isBothServicesActive}
            deviceData={deviceData}
            handleDeviceStatusDetails={handleDeviceStatusDetails}
            showEcoWidget={showEcoWidget} 
          />
          {isMultiService && showUpgradeEcoProSection && !showEcoWidget && (
            <>
              <SectionHeader
                imageSrc={sparkleWandIcon}
                title={t("BROTHER_PLUS.EASY_PAY_BANNER.BANNER_DIVIDER_TXT")}
              />
              <div className="my-device-ecopro-upgrade-block">
                <UpgradeToEcoProBlock
                  showUpgradeSectionMyDevices={handleUpgradeBlockSectionVisibility}
                  source={SOURCE_MY_DEVICE}
                />
              </div>
            </>
          )}
        </>
      ) : (
        <EcoProDashboard
          source={SOURCE_MY_DEVICE}
          selectedDeviceID={deviceData?.deviceId}
          isBothEnrolledServices={isBothServicesActive}
          deviceData={deviceData}
          handleDeviceInfoDetails={handleDeviceInfoDetails}
          handleDeviceStatusDetails={handleDeviceStatusDetails}
          showBplusWidget={showBplusWidget}
        />
      )}
    </>
  );
};

export default SuppliesComponent;